<template>
<Modal label="Data Studio">
    <InputCustom
      v-model="item.topic" 
      :error="error.topic"
      :errorMsg="errorMsg.topic"
      @onFocus="resetError('topic')"
      placeholder="Topik"
      label="Topik"
    >
    </InputCustom>

    <InputCustom
      v-model="item.link" 
      :error="error.link"
      :errorMsg="errorMsg.link"
      @onFocus="resetError('link')"
      placeholder="Link Berkas"
      label="Link Berkas"
    >
    </InputCustom>

    <div class="y-inputField">
        <div class="y-labelText">
           Dosen Pembimbing
        </div>
        <div class="y-inputPlace y-hasIcon-right">
            <div class="y-select-hasIcon" style="width: 100%">
                <select class="y-select" v-model="item.lecture_id">
                    <option class="y-option"
                      v-for="(l,i) in list.filter(x => x.id != item.id)" 
                      :key="`list-data-${i}`"
                      :value="l.id"
                      >{{l.name}}</option>
                </select>
                <div class="y-select-icon" >
                    <img :src="require('@/assets/icons/others/arrowDown.svg')" alt="">
                </div>
            </div>
        </div>
    </div>

    <div class="y-inputField">
        <div class="y-labelText">
            Status Pendaftaran
        </div>
        <div class="r-center-flex">
            <div class="r-center-flex" style="margin-right: 15px">
                <img :src="require(`@/assets/icons/checkmark/${item.status == 1 ? 'Active' : 'Inactive'}.svg`)" @click.prevent="item.status = 1;" style="margin-right: 8px" >
                Verifikasi
            </div>
            <div class="r-center-flex">
                <img :src="require(`@/assets/icons/checkmark/${item.status == 99 ? 'Active' : 'Inactive'}.svg`)" @click.prevent="item.status = 99;" alt="" style="margin-right: 8px">
                Tolak
            </div>
        </div>
         <div class="y-errorText y-red-text" :style="error.status ? 'opacity: 1 !important;': ''">
            {{errorMsg.status}}
        </div>
    </div>

    <template #actionButton>
      <ButtonCustom
        :disabled="loading" type="secondary" size="sm" class="r-mlr-10"
        @click.prevent="resetData()"
      > Batal </ButtonCustom>
      
      <ButtonCustom
        :loading="loading"
        type="primary" size="sm" class="r-mlr-10"
        @click.prevent="sendData()"
      >Submit </ButtonCustom>
    </template>
</Modal>
</template>
<script>
import common from '@/mixins/function/common'
import { mapGetters, mapActions } from 'vuex'
import validation from '@/mixins/function/validation'
import Modal from '@/components/Helper/Modal'

export default {
  mixins: [common, validation],
  components: {
    Modal,
  },
  computed: {
    ...mapGetters({
      item: 'studio/getItem',
      list: 'user/getLecture'
    })
  },
  data: () => ({
    loading: false,
    error: {
      topic: false,
      link: false,
      lecture_id: false,
    },
    errorMsg: {
      topic: 'Tidak boleh kosong',
      link: 'Tidak boleh kosong',
      lecture_id: 'Tidak boleh kosong',

    },
  }),
  methods: {
    ...mapActions({
      store: 'studio/store',
      update: 'studio/update',
    }),
    resetData(){
      this.$emit('resetData')
    },
    async validation(){
      const field = [
        'topic',
        'link',
        'lecture_id',
      ]
      return await this.validate(field,this.item)
    },
    async sendData(){
      const errorcount = await this.validation()
      if(errorcount === 0){

        this.loading = true
        await this.update(this.item)
        this.loading = false

        const response = this.getResponse('studio')
        this.showSnackbar({
          type: response.status == 1 ? "success" : "error",
          text: response.msg
        })

        if(response.status === 1){
          this.resetData()
          this.$emit('getData')
        }
      }else{
        this.showSnackbar({
          type: "error",
          text: "Mohon periksa kembali"
        })
      }
    },
  }
}
</script>